module.exports = __webpack_public_path__ + "static/rim-c46083f7aeddbfccded9394173075ae9.png";